import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke103aRequest, Sgke103aResponse, Sgke103aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke103aService {

  /**
   * コンストラクタ
   * @param {Sgke103aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke103aService
   */
  constructor(public service: Sgke103aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * Sgke103aAPI実行
   *
   * @param {Sgke103aRequest} request
   * @return {*}  {Observable<Sgke103aResponse>}
   * @memberof UsedSgke103aService
   */
  public doSgke103a(request: Sgke103aRequest): Observable<Sgke103aResponse> {

    return this.service.sgke103aPost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE103A');
          return throwError(err.message);
        })
      );
  }

}

